import { MultiContainer, Typography } from '@shared/ui'
import styles from './TopContent.module.scss'
import { useTranslation } from 'react-i18next'
import { useMainSectionQuery } from '@shared/api/useMainSectionQuery'
import { RegisterBtn } from '@widgets/header/ui/registerBtn/RegisterBtn'

export const TopContent = () => {
  const { t } = useTranslation()
  const { data } = useMainSectionQuery()
  return (
    <div className={styles.topContent}>
      <MultiContainer>
        <Typography 
          variant='h2medium' 
          className={styles.title}
          color='white'
        >
          {data?.title || t('noData')}
        </Typography>
      </MultiContainer>
      <RegisterBtn className={styles.btn}/>
    </div>
  )
}
